import { useState } from "react";

export const useFontSize = (initialSize = 18) => {
  const [FontSize, setFontSize] = useState(initialSize);
  const [questionSeparated, setQuestionSeparated] = useState({
    BorderStyle: "dashed",
    BorderColor: "rgba(68, 68, 68, 1)",
    BorderWidth: 3,
    width: 100,
  });

  const moreFontSize = () => {
    setFontSize((prev) => {
      if (prev < 50) {
        return prev + 1;
      }
      return prev;
    });
  };

  const lessFontSize = () => {
    setFontSize((prev) => {
      if (prev > 14) {
        return prev - 1;
      }
      return prev;
    });
  };

  const resetFontSize = (activeQuestions) => {
    let originalFontSize = 18;
    const firstQ = activeQuestions && activeQuestions[0];
    if (firstQ && firstQ.CustomStyle && firstQ.CustomStyle.FontSize) {
      originalFontSize = firstQ.CustomStyle.FontSize;
    }
    setFontSize(originalFontSize);
  };

  return {
    FontSize,
    setFontSize,
    questionSeparated,
    setQuestionSeparated,
    moreFontSize,
    lessFontSize,
    resetFontSize,
  };
};
